'use client';

import Link from 'next/link';
import { useBlogTheme } from '@/hooks/useBlogTheme';

export const Breadcrumbs = ({ blogTitle, blogSlug }) => {
  const { isBlogLightTheme } = useBlogTheme();

  const breadcrumbItems = [
    { label: 'Home', href: '/' },
    { label: 'Blog', href: '/blog' },
    { label: blogTitle, href: null }, // Current page, not clickable
  ];

  return (
    <nav aria-label="Breadcrumb" className={`mb-6`}>
      <ol className="flex items-center flex-wrap gap-2 text-sm font-inter-tight">
        {breadcrumbItems.map((item, index) => {
          const isLast = index === breadcrumbItems.length - 1;

          return (
            <li key={index} className="flex items-center gap-2">
              {!isLast ? (
                <>
                  <Link
                    href={item.href}
                    className={`transition-colors ${
                      isBlogLightTheme
                        ? 'text-[#515151] hover:text-black'
                        : 'text-[#999999] hover:text-white'
                    }`}
                  >
                    {item.label}
                  </Link>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={
                      isBlogLightTheme ? 'text-[#515151]' : 'text-[#999999]'
                    }
                    aria-hidden="true"
                  >
                    <path
                      d="M6 12L10 8L6 4"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </>
              ) : (
                <span
                  className={`${
                    isBlogLightTheme ? 'text-black' : 'text-white'
                  } line-clamp-1`}
                  aria-current="page"
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
